var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowAngle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "61px",
    viewBox: "0 0 63 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "56CC6662-4562-433A-873B-AA982B03BC18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12.-Drug-interactions-UI",
    transform: "translate(-495.000000, -299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(473.000000, 274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(22.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.40508495,61 C1.37494036,61 0.421932203,60.3430227 0.105506953,59.322646 C-0.282456115,58.0715718 0.432922071,56.7480219 1.70339226,56.3660442 C12.9700803,52.9790793 22.5515861,46.4589168 30.1814574,36.9868481 C35.9019946,29.8852465 38.6409599,23.361205 39.3443115,21.5307333 C39.8141802,20.3074244 41.2028433,19.6912786 42.445113,20.1536942 C43.6875902,20.616314 44.3138053,21.9833494 43.8437292,23.2066582 C43.0783782,25.1988223 40.1030271,32.2922577 33.9505673,39.9299756 C25.7027752,50.1690622 15.3260591,57.2230953 3.10843649,60.8960841 C2.87433157,60.9663141 2.63773837,61 2.40508495,61",
    id: "Fill-1",
    fill: "#2D1C45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5931401,28 C59.6827266,28 58.8115442,27.4855431 58.405117,26.612201 L48.5205084,5.36821666 L32.0720381,11.1795221 L43.7104279,16.0131536 C44.9369745,16.5226717 45.5146491,17.9211715 45.0009069,19.1373476 C44.4871646,20.3531122 43.0758783,20.9255999 41.8497468,20.4164933 L24.4773707,13.2015436 C23.5603148,12.8206397 22.9737146,11.9201343 23.0009066,10.9348464 C23.027891,9.94955848 23.6628557,9.08197832 24.5994234,8.75128541 L48.9769606,0.138864887 C50.1503687,-0.275581613 51.4495658,0.265832856 51.9716109,1.38776052 L62.7780496,24.6126098 C63.334967,25.8096482 62.8077325,27.2276973 61.6002825,27.7800182 C61.2735632,27.9292107 60.9306532,28 60.5931401,28",
    id: "Fill-3",
    fill: "#DF6532"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAngle);
export default __webpack_public_path__ + "static/media/arrowAngle.6de60df4.svg";
export { ForwardRef as ReactComponent };